import React from 'react';

export default function Divider() {
  return <hr className="rec-divider" />;
}
